<template>
  <Layout>
    <section class="csms-settlement">

      <!-- Page Title Start -->
      <PageHeader :title="title" />
      <!-- Page Title End -->

      <!-- Search Area Start -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">

                <!-- // Search Input -->
                <div class="col-xl-10 ion-mb-mb-100">
                  <div class="row">
                    <div class="col-xl-3">
                      <label class="form-label" for="settlement-search-period">{{ $t('settlement.period2') }}</label>
                      <div>
                        <date-picker class="w-100" v-model="searchForm.period" type="date" range
                                     :placeholder="$t('alert.selectDateRange')" :clearable="false" />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- // Search Button -->
                <div class="col-xl-2 align-content-end">
                  <div class="float-end">
                    <b-button variant="secondary" class="me-3" @click="reset">
                      <i class="uil uil-redo me-2"></i>
                      <span>{{ $t('btn.reset') }}</span>
                    </b-button>
                    <b-button variant="primary" @click="search">
                      <i class="uil uil-search me-2"></i>
                      <span>{{ $t('btn.search') }}</span>
                    </b-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Search Area End -->

      <!-- List Start -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">

              <!-- // List Title -->
              <h5 class="mb-3 fw-bold">{{ $t('settlement.ultraPlanSettlementStatus') }}</h5>

              <!-- // List -->
              <div class="table-responsive">
                <b-table class="text-nowrap align-middle" bordered hover
                         show-empty :empty-text="$t('settlement.noData')"
                         :fields="fields" :items="itemsWithTotal"
                         :tbody-tr-class="rowClass"
                         @row-clicked="onRowClick">

                  <template #head()="data">
                    <span v-if="!$_utils.isEmpty(data.label)">{{ $t(`settlement.${data.column}`) }}</span>
                  </template>

                  <template #cell(hqName)="data">
                    <span :class="{ 'fw-bold': data.item._isTotal }">{{ data.item.hqName || '-' }}</span>
                  </template>

                  <template #cell(ultraChargeEnergyRate)="data">
                    <span :class="{ 'fw-bold': data.item._isTotal }">
                      {{ !$_utils.isEmpty(data.item.ultraChargeEnergyRate) ? $_utils.comma(data.item.ultraChargeEnergyRate) + '%' : '-' }}
                    </span>
                  </template>

                  <template #cell(ultraChargeEnergyKwh)="data">
                    <span :class="{ 'fw-bold': data.item._isTotal }">
                      {{ !$_utils.isEmpty(data.item.ultraChargeEnergyKwh) ? $_utils.comma(data.item.ultraChargeEnergyKwh) : '-' }}
                    </span>
                  </template>

                  <template #cell(divideAmt)="data">
                    <span :class="{ 'fw-bold': data.item._isTotal }">
                      {{ !$_utils.isEmpty(data.item.divideAmt) ? $_utils.comma(data.item.divideAmt) : '-' }}
                    </span>
                  </template>

                  <template #cell(discountChargeFeeB)="data">
                    <span :class="{ 'fw-bold': data.item._isTotal }">
                      {{ !$_utils.isEmpty(data.item.discountChargeFee) ? $_utils.comma(data.item.discountChargeFee) : '-' }}
                    </span>
                  </template>

                  <template #cell(differenceAmtAB)="data">
                    <span :class="{ 'fw-bold': data.item._isTotal }">
<!--                      {{ !$_utils.isEmpty(data.item.differenceAmt) ? $_utils.comma(data.item.differenceAmt) : '-' }}-->
                      {{ !$_utils.isEmpty(data.item.divideAmt) && !$_utils.isEmpty(data.item.discountChargeFee)
                        ? $_utils.comma(data.item.divideAmt - data.item.discountChargeFee) : '-' }}
                    </span>
                  </template>

                </b-table>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- List End -->

      <!-- List 2 Start -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">

              <!-- // List Title -->
              <h5 class="mb-3 fw-bold">{{ $t('settlement.detailedinformation') }}</h5>

              <!-- // List -->
              <div class="table-responsive">
                <b-table class="text-nowrap align-middle" bordered hover
                         show-empty :empty-text="$t('settlement.noData')"
                         :fields="fields2" :items="items2">

                  <template #head()="data">
                    <span v-if="!$_utils.isEmpty(data.label)">{{ $t(`settlement.${data.column}`) }}</span>
                  </template>

                  <template #cell(chargeEnergyKwh)="data">
                    {{ !$_utils.isEmpty(data.item.chargeEnergyKwh) ? $_utils.comma(data.item.chargeEnergyKwh) : '-' }}
                  </template>

                  <template #cell(beforeDiscountChargeFee)="data">
                    {{ !$_utils.isEmpty(data.item.beforeDiscountChargeFee) ? $_utils.comma(data.item.beforeDiscountChargeFee) : '-' }}
                  </template>

                  <template #cell(discountAmt)="data">
                    {{ !$_utils.isEmpty(data.item.discountAmt) ? $_utils.comma(data.item.discountAmt) : '-' }}
                  </template>

                  <template #cell(discountChargeFee)="data">
<!--                    {{ !$_utils.isEmpty(data.item.discountChargeFee) ? $_utils.comma(data.item.discountChargeFee) : '-' }}-->
                    {{ !$_utils.isEmpty(data.item.beforeDiscountChargeFee) && !$_utils.isEmpty(data.item.discountAmt)
                      ? $_utils.comma(data.item.beforeDiscountChargeFee - data.item.discountAmt) : '-' }}
                  </template>

                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- List 2 End -->

      <detail-modal ref="settlementDetailModal"
                    :place-id="selectedPlaceId"
                    :auth-date="selectedAuthDate"
                    @callback="getItems" />
    </section>
  </Layout>
</template>

<script>
import { http } from '@/auth-api';
import { loadingMethods } from '@/state/helpers';
import i18n from '@/i18n';
import Layout from '@/views/layouts/Main.vue';
import PageHeader from '@/components/PageHeader.vue';
import PerPageSelector from '@/views/components/PerPageSelector.vue';
import TotalCount from '@/views/components/TotalCount.vue';
import DetailModal from '@/views/pages/settlement/settlementDetailModal.vue';


export default {
  components: {
    Layout, PageHeader, PerPageSelector, TotalCount, DetailModal
  },
  data() {
    return {
      title: 'settlementUltraPlan',
      searchConditions: [],
      sortDirection: 'DESC',
      pagination: {
        currentPage: 1,
        totalCount : 0,
        perPage: 50
      },
      pagination2: {
        currentPage: 1,
        totalCount : 0,
        perPage: 50
      },
      searchForm: {
        period: null
      },
      fields: [
        { key: 'hqName', label: '충전기운영자', class: 'text-center' },
        { key: 'ultraChargeEnergyRate', label: '플랜 할인으로 충전된 총 충전 비율', class: 'text-center' },
        { key: 'ultraChargeEnergyKwh', label: '플랜 할인으로 충전된 총 충전량', class: 'text-center' },
        { key: 'divideAmt', label: '플랜 가입비 분배 금액', class: 'text-center' },
        { key: 'discountChargeFeeB', label: '할인 누적 금액', class: 'text-center' },
        { key: 'differenceAmtAB', label: '차액', class: 'text-center' },
      ],
      fields2: [
        { key: 'rnum', label: 'No.', class: 'text-center column-w-8' },
        { key: 'placeName', label: '충전 스탠드', class: 'text-center' },
        { key: 'chargeEnergyKwh', label: '충전량', class: 'text-center' },
        { key: 'beforeDiscountChargeFee', label: '일반금액', class: 'text-center' },
        { key: 'discountAmt', label: '할인금액', class: 'text-center' },
        { key: 'discountChargeFee', label: '플랜 가입자 할인 누적 금액', class: 'text-center' },
      ],
      items: null,
      items2: null,
      selectedPlaceId: null,
      selectedAuthDate: null,
      selectedHqId: null,
      selectedStartDate: null,
      selectedEndDate: null,
    }
  },
  computed: {
    itemsWithTotal() {
      if (!this.items || this.items.length === 0) {
        return [];
      }

      // 합계 계산
      const totals = {
        hqName: i18n.t('common.sumTotal'),
        ultraChargeEnergyRate: 0,
        ultraChargeEnergyKwh: 0,
        divideAmt: 0,
        discountChargeFee: 0,
        differenceAmt: 0,
        _isTotal: true // 합계 행 표시용 플래그
      };

      this.items.forEach(item => {
        totals.ultraChargeEnergyRate += item.ultraChargeEnergyRate || 0;
        totals.ultraChargeEnergyKwh += item.ultraChargeEnergyKwh || 0;
        totals.divideAmt += item.divideAmt || 0;
        totals.discountChargeFee += item.discountChargeFee || 0;
        totals.differenceAmt += item.differenceAmt || 0;
      });

      // 합계 행을 마지막에 추가
      return [...this.items, totals];
    }
  },
  mounted() {
    const vm = this;

    // 이번달 날짜 범위를 기본값으로 설정
    vm.searchForm.period = [
      new Date(vm.$moment().startOf('month')),
      new Date(vm.$moment().endOf('month'))
    ];

    // 기본 날짜로 검색 조건 설정 후 조회
    vm.searchConditions = [];
    if (!vm.$_utils.isEmpty(vm.searchForm.period)) {
      vm.searchConditions.push({ searchKey: 'startDate', searchValue: vm.$moment(vm.searchForm.period[0]).format('YYYY-MM-DD') });
      vm.searchConditions.push({ searchKey: 'endDate', searchValue: vm.$moment(vm.searchForm.period[1]).format('YYYY-MM-DD') });
    }

    vm.getItems();
    // 초기 로드 시에는 getItems2를 호출하지 않음 (로우 클릭 시에만 호출)
  },
  methods: {
    ...loadingMethods,
    async reset() {
      const vm = this;

      vm.searchForm = {
        period: [new Date(vm.$moment().startOf('month')), new Date(vm.$moment().endOf('month'))]
      };
      vm.searchConditions = [];

      // 두 번째 테이블 데이터 초기화
      vm.items2 = null;
      vm.selectedHqId = null;
      vm.selectedStartDate = null;
      vm.selectedEndDate = null;
      vm.pagination2.totalCount = 0;

      await vm.getItems();
      // reset 시에는 getItems2를 호출하지 않음 (로우 클릭 시에만 호출)
    },
    async search() {
      const vm = this;

      vm.searchConditions = [];

      if (!this.$_utils.isEmpty(vm.searchForm.period)) {
        vm.searchConditions.push({ searchKey: 'startDate', searchValue: this.$moment(vm.searchForm.period[0]).format('YYYY-MM-DD') });
        vm.searchConditions.push({ searchKey: 'endDate', searchValue: this.$moment(vm.searchForm.period[1]).format('YYYY-MM-DD') });
      }

      // 두 번째 테이블 데이터 초기화
      vm.items2 = null;
      vm.selectedHqId = null;
      vm.selectedStartDate = null;
      vm.selectedEndDate = null;
      vm.pagination2.totalCount = 0;

      await vm.getItems();
      // search 시에는 getItems2를 호출하지 않음 (로우 클릭 시에만 호출)
    },
    async getItems() {
      const vm = this;
      const _url = '/onmapi/view/Settlement/UltraPlan/list';

      vm.showOverlay();

      await http.post(_url, {
        page: 1,
        limit: 100,
        searchConditions: vm.searchConditions,
        sortCondition: { sortDirection: vm.sortDirection }
      }).then(res => {
        vm.items = res.data.items;
        vm.pagination.totalCount = res.data.totalCount;
      }).catch(err => {
        console.error('Settlement List Error :: ', err)
      }).finally(() => {
        vm.hideOverlay();
      });
    },
    async getItems2(hqId, startDate, endDate) {
      const vm = this;
      const _url = '/onmapi/view/Settlement/UltraPlan/list/detail';

      vm.showOverlay();

      const searchConditions = [];

      if (hqId) {
        searchConditions.push({ searchKey: 'hqId', searchValue: hqId });
      }

      if (startDate) {
        searchConditions.push({ searchKey: 'startDate', searchValue: startDate });
      }

      if (endDate) {
        searchConditions.push({ searchKey: 'endDate', searchValue: endDate });
      }

      await http.post(_url, {
        page: 1,
        limit: 100,
        searchConditions: searchConditions,
        sortCondition: { sortDirection: vm.sortDirection }
      }).then(res => {
        vm.items2 = res.data.items;
        vm.pagination2.totalCount = res.data.totalCount;
      }).catch(err => {
        console.error('Settlement List 2 Error :: ', err)
      }).finally(() => {
        vm.hideOverlay();
      });
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return '';
      if (item._isTotal) return 'table-total-row';
      return '';
    },
    onRowClick(item) {
      const vm = this;

      // 합계 행 클릭 시 무시
      if (item._isTotal) {
        return;
      }

      const hqId = item.hqId;
      let startDate = null;
      let endDate = null;

      if (!vm.$_utils.isEmpty(vm.searchForm.period)) {
        startDate = vm.$moment(vm.searchForm.period[0]).format('YYYY-MM-DD');
        endDate = vm.$moment(vm.searchForm.period[1]).format('YYYY-MM-DD');
      }

      vm.selectedHqId = hqId;
      vm.selectedStartDate = startDate;
      vm.selectedEndDate = endDate;

      vm.getItems2(hqId, startDate, endDate);
    },
    async onPerPageChange() {
      const vm = this;

      if (vm.pagination.totalCount > 1) {
        vm.pagination.currentPage = 1;
        await vm.getItems();
      }
    },
    async onPageChange(val) {
      const vm = this;
      vm.pagination.currentPage = val;

      if (vm.pagination.totalCount > 1) {
        await vm.getItems();
      }
    },
    async onPageChange2(val) {
      const vm = this;
      vm.pagination2.currentPage = val;

      if (vm.pagination2.totalCount > 1 && vm.selectedHqId) {
        await vm.getItems2(vm.selectedHqId, vm.selectedStartDate, vm.selectedEndDate);
      }
    },
    viewDetail(item) {
      const vm = this;
      vm.selectedPlaceId = item.placeId;
      vm.selectedAuthDate = item.authYearMonth;

      vm.$nextTick(() => {
        this.$refs.settlementDetailModal.show();
      });
    },
    viewDetail2(item) {
      const vm = this;
      vm.selectedPlaceId = item.placeId;
      vm.selectedAuthDate = item.authYearMonth;

      vm.$nextTick(() => {
        this.$refs.settlementDetailModal.show();
      });
    }
  }
}
</script>

<style scoped>
.table-total-row {
  background-color: #f8f9fa !important;
  font-weight: 600;
}

.table-total-row:hover {
  background-color: #f8f9fa !important;
}
</style>
